export default {
  "shell.feedback.requestFailed": "Request failed ({{status}})",
  "shell.feedback.statusUnavailable": "Status unavailable",
  "shell.feedback.unknownDatabase": "unknown database error",
  "shell.feedback.apiUnavailable": "API unavailable",
  "shell.feedback.databaseUnavailable": "Database unavailable",
  "shell.feedback.upstreamUnreachable": "Upstream unreachable",
  "shell.feedback.upstreamNotConfigured": "QB_UPSTREAM_VERSION_URL not configured",
  "shell.feedback.upstreamHttp": "Upstream responded with {{status}}",
  "shell.feedback.upstreamParse": "Unable to parse upstream version",
  "shell.feedback.unknownUpstream": "unknown upstream error",
  "shell.feedback.centralTimeout": "Central request timed out after {{seconds}}s",
  "shell.feedback.credentialsFailure": "Failed to read credentials: {{detail}}",
  "shell.feedback.credentialsUnknown": "Failed to read credentials: unknown database error",
  "shell.feedback.centralHttpDetail": "Central responded with {{status}}: {{detail}}",
  "shell.feedback.centralHttp": "Central responded with {{status}}",
  "shell.feedback.centralNonJson": "Central returned non-JSON response (HTTP {{status}}): {{detail}}",
  "shell.feedback.centralMissing": "Central returned status \"{{status}}\" with no commit data",
  "shell.feedback.centralMissingUnknown": "Central returned status \"unknown\" with no commit data",
  "shell.feedback.unknownCentral": "unknown central error"
} as const;
